import createBarkerSvg from '@sparta.credit-cards.utilities/barker-utility/dist/es6.js';
import Handlebars from '@sparta.global.vendors/handlebars';
import { link } from '@sparta.global.helpers/sparta-helper/dist/es6.js';
import { checkbox } from '@sparta.global.helpers/checkbox-helper/dist/es6.js';
import starRating from '@sparta.credit-cards.utilities/star-rating-utility/dist/es6.js';

// ALL of these eslint rules should be fixed in this file someday, but alas,
// today is not that day.
/* eslint-disable no-param-reassign, consistent-return, no-unused-vars, no-shadow */
/* eslint-disable no-use-before-define */

/**
 * Current campaign
 * @param {String} campaignKey - 4020247~87~en_US
 * @param {Object} campaigns - Mapping of response payloads from ProductProperties
 * @param {Object} options - Options
 * @returns {String} current campaign
 */
function currentCampaign(campaignKey, campaigns, options) {
  return options.fn({});
}

/**
 * Get object value
 * @param {Object} obj object
 * @param {string} val value
 * @return {string} object value
 */
function getObjectValue(obj, val) {
  if (obj) {
    return obj[val];
  }
  return '';
}

/**
 * Strip tag
 * @param {String} value value
 * @returns {String} HTML content
 */
function stripTag(value) {
  const div = document.createElement('div');
  div.innerHTML = value;
  div.innerHTML = div.innerHTML.replace('<p>', '').replace('</p>', '').replace('<h1>', '').replace('</h1>', '').replace('<h2>', '').replace('</h2>', '').replace('<h3>', '').replace('</h3>', '').replace('<h4>', '').replace('</h4>', '').replace('<h5>', '').replace('</h5>', '').replace('<h6>', '').replace('</h6>', '');
  return div.innerHTML;
}

/**
 * Strip List
 * @param {String} value value
 * @returns {String} HTML content
 */
function stripList(value) {
  const div = document.createElement('div');
  div.innerHTML = value;
  div.innerHTML = div.innerHTML.replace('<ul>', '').replace('</ul>', '').replace('<li>', '').replace('</li>', '');
  return div.innerHTML;
}

/**
 * Network benefits header
 * @param {String} ref reference
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @returns {String} options
 */
function premiumBenefitsHead(ref, campaignProperties, options) {
  if (!campaignProperties || Object.keys(campaignProperties).indexOf('name') !== -1) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (`${ref}`.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      const data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_HEADER_XX = campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_INACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
}

/**
 * Network benefits content
 * @param {String} ref reference
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @returns {String} content
 */
function premiumBenefitsContent(ref, campaignProperties, options) {
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (`${ref}`.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      const data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_HEADER_XX = campaignProperties[`NETWORK_BENEFITS_HEADER${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_CONTENT${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_CONTENT_XX = campaignProperties[`NETWORK_BENEFITS_CONTENT${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
}

/**
 * Network benefits icons
 * @param {String} ref reference
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options
 * @returns {String} content
 */
function premiumBenefitsIcon(ref, campaignProperties, options) {
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (`${ref}`.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      const data = Handlebars.createFrame(options.data);
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_TABID${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_TABID_XX = campaignProperties[`NETWORK_BENEFITS_TABID${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_ACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_ACTIVE_ICON${ref}`];
      if (Handlebars.Utils.isEmpty(campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`])) {
        return '';
      }
      data.NETWORK_BENEFITS_INACTIVE_ICON_XX = campaignProperties[`NETWORK_BENEFITS_INACTIVE_ICON${ref}`];
      options.data = data;
    }
    return options.fn(options.data);
  }
}

/**
 * Network benefits Swap Icons
 * This is to override the PCM icons
 * @param {String} ref reference
 * @param {Object} icons icon obj
 * @returns {String} content
 */
function premiumBenefitsIconSwap(ref, icons) {
  // Checks if the reference given matches with an existing icon in the icon list
  // if so then return the imagepath
  if (ref.NETWORK_BENEFITS_TABID_XX === icons.iconName) {
    return new Handlebars.SafeString(`<img src='${icons.imagePath}' alt=''></img>`);
  }
}

/**
 * Current offer
 * @param {String} campaignKey campaign key
 * @param {Array} offers offers array
 * @param {Object} options options
 * @returns {String} current offer
 */
function currentOffer(campaignKey, offers, options) {
  // Create cache
  let cache;

  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // if offer campaign code
    if (offerCampaignKey === campaignKey) {
      cache = offer;
    }
  }

  // If undefined
  if (cache === undefined) {
    return false;
  }

  // Return options
  return options.fn(cache);
}

/**
 * Current offers based off query params
 * @param  {Object} queries queries
 * @param  {Array} offers offers
 * @param  {Object} options options
 * @returns {String} current offer
 */
function currentOfferBasedOffQueryParams(queries, offers, options) {
  // Read pocode
  const poCode = queries.termspocode.value;

  // Read campaign id
  const campaignID = queries.termscampaignid.value;

  // Create cache
  let cache;

  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // request terms and conditions params
    const queryParamsCampaignKey = `${campaignID}~${poCode}`;
    console.log('route: ', queryParamsCampaignKey);
    console.log('trying to match: ', offerCampaignKey);

    // if offer campaign code
    if (offerCampaignKey === queryParamsCampaignKey) {
      cache = offer;
    }
  }
  console.log(cache);

  // If undefined
  if (cache === undefined) {
    return options.fn({});
  }
  return options.fn(cache);
}

/**
 * Omit offers
 * @param  {String} campaignKey campaign Key
 * @param  {Array} offers offers
 * @param  {Object} options options
 * @returns {Object} offers
 */
function omitOffers(campaignKey, offers, options) {
  // Cache array
  const cache = [];

  // Loop through offers
  for (let i = 0; i < offers.length; i++) {
    // Cache offer
    const offer = offers[i];

    // Offer campaign key
    const offerCampaignKey = `${offer.campaignNumber}~${offer.productOfferCode}`;

    // if offer campaign code
    if (offerCampaignKey !== campaignKey) {
      cache.push(offer);
    }
  }

  // Return options
  return options.fn(cache);
}

/**
 * Omit campaign
 * @param {String} campaignKey - 4020247~87~en_US
 * @param {Object} campaigns - Mapping of response payloads from ProductProperties
 * @param {Object} options - Options
 * @returns {String} omit campaign
 */
function omitCampaign(campaignKey, campaigns, options) {
  return options.fn({});

  // Function is no longer used, code omitted.
}

/**
 * Active page scrolling
 * @param {Array} offers offers
 * @param {Object} options options
 * @return {String} active page scrolling
 */
function activePageScrolling(offers, options) {
  if (offers.length === 1) {
    return options.fn({});
  }
  return options.fn(offers);
}

/**
 * @description Return the value for a single token if available in provided object.
 *  Otherwise, return token string.
 * @param {String} key key
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @return {String} token
 */
function token(key, campaignProperties, options) {
  // if no object map is passed, throw an error.
  if (!campaignProperties || !Object.keys(campaignProperties).length) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  const tokenPattern = /\$\{([^}]*)\}/;
  const parsedKey = tokenPattern.test(key) ? key.match(tokenPattern)[1] : key;
  if (campaignProperties[parsedKey]) {
    return campaignProperties[parsedKey];
  }
  if (typeof options === 'undefined') {
    options = {
      hash: {}
    };
  }
  // eslint-disable-next-line eqeqeq
  if (!!options.hash.showEmpty && options.hash.showEmpty != 'false') {
    return '';
  }
  return key;
}

/**
 * @param {String} key key
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @return {Boolean} token populated
 */
function tokenPopulated(key, campaignProperties, options) {
  // if no object map is passed, throw an error.
  if (!campaignProperties || !Object.keys(campaignProperties).length) {
    throw new Error('Please provide and object representing the campaignProperties object');
  }
  const tokenPattern = /\$\{([^}]*)\}/;
  const parsedKey = tokenPattern.test(key) ? key.match(tokenPattern)[1] : key;
  return !!campaignProperties[parsedKey];
}

/**
 * @name applyNow
 * @param {Object} link JCR content in sparta link format
 * @param {String} requestType C or BCC
 * @param {String} campaignId Campaign id
 * @param {Object} site spaParams.siteParams
 * @param {Object} sparta global sparta obj
 * @param {Boolean} isBya before you apply link or not
 * @param {Boolean} catalog catalog
 * @param {Boolean} performanceMeta performance meta
 * @param {Boolean} isUSA redirect to USA or not
 * @return {String} HTML apply now button
 */

function applyNow(link$1, requestType, campaignId, site, sparta, isBya = false, catalog = null, performanceMeta = '', isUSA = false) {
  let url = '';
  const queryString = window.location.search.substring(1);
  const campaignParts = campaignId.split('~');
  if (isBya && isBya != 'NO' && isUSA && isUSA != 'NO') {
    // USA get started
    let getStartedPageUrl = site.usaGetStartedPage;
    getStartedPageUrl = sparta.language === 'en' ? getStartedPageUrl.replace('{language}', '') : getStartedPageUrl.replace('{language}', '/es');
    url += `${spaParams.siteParams.domain.hostname}${getStartedPageUrl}`;
    url += `?campaignId=${campaignParts[0]}`;
    url += `&productOfferCode=${campaignParts[1]}`;
  } else if (isUSA && isUSA != 'NO' && (!isBya || isBya === 'NO')) {
    // USA application
    url += `${spaParams.siteParams.secureHost}${site.usaApplicationEndpoint}`;
    url += '?requesttype=usa';
    url += `&campaignId=${campaignParts[0]}`;
    url += `&productOfferCode=${campaignParts[1]}`;
    url += `&locale=${campaignParts[2]}`;
  } else if (isBya && isBya != 'NO' && (!isUSA || isUSA === 'NO')) {
    // existing bya page
    url += `${site.siteRoot}/before-you-apply/`;
    if (sparta.language !== 'en') {
      url += `${sparta.language}/`;
    }
    url += `?campaign=${campaignId}`;
  } else {
    url += `${site.abpaEndpoint}`;
    url += `?requesttype=${requestType}`;
    url += `&campaignid=${campaignParts[0]}`;
    url += `&productoffercode=${campaignParts[1]}`;
    url += `&locale=${campaignParts[2]}`;
    if (queryString) {
      url += `&${queryString}`;
    }
  }
  if (catalog && catalog.marketingTrack && catalog.marketingCode) {
    url += `&mktg_track=${catalog.marketingTrack}&track=${catalog.marketingCode}`;
  }
  link$1.URL = url;

  // add performance classes for prefetch and/or preload performance meta
  const VALID_META = ['prefetch', 'preconnect', 'prerender', 'crossorigin'];
  if (Array.isArray(performanceMeta) && performanceMeta.length > 0) {
    let performanceClasses = '';
    performanceMeta.forEach(rel => {
      if (VALID_META.indexOf(rel) !== -1) {
        performanceClasses += `spa-${rel} `;
      }
    });
    if (performanceClasses) link$1.CLASS = `${performanceClasses}${link$1.CLASS}`;
  } else if (typeof performanceMeta === 'string' && VALID_META.indexOf(performanceMeta) !== -1) {
    link$1.CLASS = `spa-${performanceMeta} ${link$1.CLASS}`;
  }
  return link(link$1);
}

/**
 * learnMore
 *
 * @description Builds the anchor
 * @param {Object} link JCR content in sparta link format
 * @param {Object} learnMore JCR content
 * @param {String} campaignId campaign ID
 * @param {Object} site spaParams.siteParams
 * @param {Object} performanceMeta performance meta
 * @return {String} learn more link
 */
function learnMore(link$1, learnMore, campaignId, site, performanceMeta = '') {
  link$1.URL = learnMoreUrl(learnMore, campaignId, site);

  // add performance classes for prefetch and/or preload performance meta
  const VALID_META = ['prefetch', 'preconnect', 'crossorigin'];
  if (Array.isArray(performanceMeta) && performanceMeta.length > 0) {
    let performanceClasses = '';
    performanceMeta.forEach(rel => {
      if (VALID_META.indexOf(rel) !== -1) {
        performanceClasses += `spa-${rel} `;
      }
    });
    if (performanceClasses) link$1.CLASS = `${performanceClasses}${link$1.CLASS}`;
  } else if (typeof performanceMeta === 'string' && VALID_META.indexOf(performanceMeta) !== -1) {
    link$1.CLASS = `spa-${performanceMeta} ${link$1.CLASS}`;
  }
  return link(link$1);
}

/**
 * learnMoreLink
 *
 * @description Builds the learn more url
 * @param {Object} learnMoreObj JCR content
 * @param {String} campaignId campaign id
 * @param {Object} site spaParams.siteParams
 * @return {String} url
 */
function learnMoreUrl(learnMoreObj, campaignId, site) {
  const {
    path,
    passCampaign
  } = learnMoreObj || {};
  let url = `${site.siteRoot}/${path}`;
  if (passCampaign) {
    url += `?campaign=${campaignId}`;
  }
  return url;
}

/**
 * termsAndConditions
 *
 * @param {Object} termsLink JCR content in sparta link format
 * @param {String} campaignId campaign ID
 * @param {Object} site spaParams.siteParams
 * @param {Object} sparta sparta
 * @param {Boolean} hasOfferTerms has offer terms
 * @param {String} termsLabel offer terms label
 * @return {String} link helper
 */
function termsAndConditions(termsLink, campaignId, site, sparta, hasOfferTerms, termsLabel) {
  const myTermsLink = termsLink;
  const campaignParts = campaignId.split('~');
  let url = `${site.siteRoot}/${site.tncUrl}`;
  if (sparta.language !== 'en') {
    url += `${sparta.language}/`;
  }
  url += `?campaignid=${campaignParts[0]}`;
  url += `&productoffercode=${campaignParts[1]}`;
  url += `&locale=${campaignParts[2]}`;
  myTermsLink.URL = url;
  if (hasOfferTerms && typeof hasOfferTerms === 'boolean') {
    myTermsLink.URL = `${url}#features`;
    myTermsLink.content = termsLabel;
  }
  return link(myTermsLink);
}

/**
 * getProgramRulesLink
 *
 * @param {Object} programRulesLink JCR content in sparta link format
 * @param {Object} programRulesLabel program rules label
 * @param {Object} programRulesHref program rules href
 * @return {String} link helper
 */
function getProgramRulesLink(programRulesLink, programRulesLabel, programRulesHref) {
  const rulesLink = programRulesLink;
  rulesLink.URL = programRulesHref;
  rulesLink.content = programRulesLabel;
  return link(rulesLink);
}

/**
 * @param {String} linkName link name
 * @param {String} name name
 * @param {String} adaValue ada value
 * @param {String} campaignId campaign ID
 * @param {String} productOfferCode product offer code
 * @param {String} linkText link text
 * @return {String} terms and conditions link
 */
function termsAndConditionsSB(linkName, name, adaValue, campaignId, productOfferCode, linkText) {
  const href = `/smallbusiness/credit-cards/terms-and-conditions/?campaignid=${campaignId}&productoffercode=${productOfferCode}&locale=en_US`;
  return [`<a class="terms-and-conditions-card" href="javascript:void(0);" data-href="${href}" id="${linkName}" data-width="600" data-height="600">`, linkText, `<span class="ada-hidden"> ${adaValue}</span>`, '</a>'].join('');
}

/**
 * compareProduct
 *
 * @description Renders the compare checkbox
 * @param {String} campaignId campaign ID
 * @param {String} compareId compare ID
 * @param {String} label label
 * @param {String} product product
 * @param {String} image image
 * @param {String} barkerText barker text
 * @param {String} barkerPosition position barker position
 * @param {String} barkerColor color barker color
 * @return {String} HTML compare checkbox
 */
function compareProduct(campaignId, compareId, label, product, image, barkerText, barkerPosition, barkerColor, productName) {
  const checkboxData = {
    // id: `group-compare-${campaignId}`,
    direction: 'horizontal',
    checkboxes: [{
      label: {
        text: label,
        adaText: product
      },
      checkbox: {
        attrs: {
          id: `compare-${campaignId}`,
          name: `compare-${campaignId}`,
          value: compareId,
          'data-campaign': compareId,
          'data-parent': campaignId,
          'data-product': product,
          'data-image': image,
          'data-barker-text': barkerText || '',
          'data-barker-position': barkerPosition || '',
          'data-barker-color': barkerColor || '',
          'aria-label': `${label} ${productName}` // action and context for screen readers
          // ie. "Add to compare Business Advantage Travel Rewards World Mastercard® credit card"
        }
      }
    }]
  };
  return new Handlebars.SafeString(`<div class="compare-selector">${checkbox(checkboxData)}</div>`);
}

/**
 *
 * @param {String} ref reference
 * @param {Object} campaignProperties campaign properties
 * @param {Object} options options
 * @return {Object} card data
 */
function cardDetails(ref, campaignProperties, options) {
  if (parseInt(ref, 10) > 0) {
    // check to be sure a number is passed in
    if (`${ref}`.length < 2) {
      // pad to a 2-digit number with leading zero
      ref = `_0${ref}`;
    } else {
      ref = `_${ref}`;
    }
    if (options.data) {
      const data = Handlebars.createFrame(options.data);
      if (!Handlebars.Utils.isEmpty(campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`])) {
        data.CARD_PRODUCT_DETAILS_ICON_XX = campaignProperties[`CARD_PRODUCT_DETAILS_ICON${ref}`];
      }
      data.CARD_PRODUCT_DETAILS_HEADER_XX = campaignProperties[`CARD_PRODUCT_DETAILS_HEADER${ref}`];
      data.CARD_PRODUCT_DETAILS_CONTENT_XX = campaignProperties[`CARD_PRODUCT_DETAILS_CONTENT${ref}`];
      if (data.CARD_PRODUCT_DETAILS_CONTENT_XX && data.CARD_PRODUCT_DETAILS_CONTENT_XX.indexOf('<p') === -1) {
        data.CARD_PRODUCT_DETAILS_CONTENT_XX = `<p>${data.CARD_PRODUCT_DETAILS_CONTENT_XX}</p>`;
      }
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = data.CARD_PRODUCT_DETAILS_CONTENT_XX;
      const paragraphs = tempDiv.querySelectorAll('p');
      const detailsParagraph = tempDiv.querySelector('p.details');
      data.CARD_PRODUCT_DETAILS_CONTENTS_XX = [];
      if (paragraphs.length && !detailsParagraph) {
        [...paragraphs].forEach(p => {
          if (!p.textContent.length) {
            p.remove();
          } else {
            data.CARD_PRODUCT_DETAILS_CONTENTS_XX.push(p.outerHTML);
          }
        });
      } else if (detailsParagraph) {
        // Show hide details content, p.details is used, avoid nested paragraphs
        data.CARD_PRODUCT_DETAILS_CONTENTS_XX.push(data.CARD_PRODUCT_DETAILS_CONTENT_XX);
      } else {
        data.CARD_PRODUCT_DETAILS_CONTENTS_XX.push(`<p>${data.CARD_PRODUCT_DETAILS_CONTENT_XX}</p>`);
      }
      options.data = data;
    }
    return options.fn(options.data);
  }
}

/**
 * barker
 *
 * @todo Need to find out all the classes for the barker and check against it and add these styles
 * to the credit-cards/style-utility... seems we need to make one...
 * @description Renders the ribbon thing near the cards
 * @param {String} text barker text
 * @param {String} barkerPosition barker position
 * @param {String} cardData card data
 * @param {String} barkerColor barker color
 * @return {String} HTML barker
 */
function barker(text, barkerPosition = 'left', cardData, barkerColor = 'blue') {
  const barkerSvg = createBarkerSvg(text, barkerPosition, cardData, barkerColor);
  return barkerSvg;
}

/**
 * now utilizes the starRating utility to keep rating code in one place
 *
 * @description code moved to credit-cards/star-rating-utility
 * @param {Object} params params
 * @return {String} HTML rating
 */
function rating(params) {
  return new Handlebars.SafeString(starRating(params));
}

/**
 *
 * @param {String} content content
 * @param {Object} options options
 * @return {String} escaped HTML
 */
function htmlEscaper(content, options) {
  if (content) {
    return content.replace(/"/g, '\\"').replace(/\n/g, '\\n');
  }
  return null;
}

/**
 *
 * @param {Object} linkObj link object
 * @param {Object} codes codes
 * @param {String} abpaEndPoint ABPA endpoint
 * @return {Object} Apply Now link object
 */
function updateApplyNowUrl(linkObj, codes, abpaEndPoint) {
  let href;
  href = `?requesttype=C&campaignid=${codes.campaignID}&locale=${codes.locale}&productoffercode=${codes.poCode}&groupcode=${codes.group}`;
  href = `${abpaEndPoint}${href}`;
  linkObj.URL = href;
  linkObj.content = `${linkObj.content}<span class="ada-hidden"> for ${codes.title}</span>`;
  return linkObj;
}
/**
* Helper to construct pagination markup from given paginated results.
* @param {Object} pages object returned from the paginate utility function.
* @returns {String} markup for the page's pagination section.
*/
function paginate(pages) {
  const {
    currentPage,
    previousPage,
    nextPage,
    numPages
  } = pages;
  let paginatedMarkup = '';

  /**
  |--------------------------------------------------
  | Three types of pagination, based on current page.
  | If 4 pages or less, display all at once.
  |--------------------------------------------------
  */

  // First 3 pages
  if (numPages > 4) {
    if (currentPage < 4) {
      [1, 2, 3, 4].forEach(page => {
        paginatedMarkup += `
            <a id="page${page}" class="page-number nav-link${currentPage === page ? ' current' : ''}">${page}</a>
          `;
      });
      paginatedMarkup += `
          <span class="pagination-ellipsis">...</span>
          <a id="page${numPages}" class="page-number nav-link final">${numPages}</a>
        `;
    } else if (currentPage >= 4 && currentPage < numPages - 2) {
      // Pages from 4 to 2 below max
      paginatedMarkup += `
          <a id="page1" class="page-number nav-link first">1</a>
          <span class="pagination-ellipsis">...</span>
          <a id="page${previousPage}" class="page-number nav-link">${previousPage}</a>
          <a id="page${currentPage}" class="page-number nav-link current">${currentPage}</a>
          <a id="page${nextPage}" class="page-number nav-link">${nextPage}</a>
          <span class="pagination-ellipsis">...</span>
          <a id="page${numPages}" class="page-number nav-link final">${numPages}</a>
        `;
    } else if (currentPage >= numPages - 2) {
      // Last four pages
      paginatedMarkup += `
          <a id="page1" class="page-number nav-link first">1</a>
          <span class="pagination-ellipsis">...</span>
        `;
      [numPages - 3, numPages - 2, numPages - 1, numPages].forEach(page => {
        paginatedMarkup += `
            <a id="page${page}" class="page-number nav-link${currentPage === page ? ' current' : ''}">${page}</a>
          `;
      });
    }
  } else {
    for (let page = 1; page <= numPages; page++) {
      paginatedMarkup += `
          <a id="page${page}" class="page-number nav-link${currentPage === page ? ' current' : ''}">${page}</a>
        `;
    }
  }
  return paginatedMarkup;
}
/**
* Helper to get the file name from a path.
* @param {String} path the asset path
* @returns {String} the filename
*/
function fileName(path) {
  return path.substring(path.lastIndexOf('/')).replace('/assets-images-site-credit-cards-', '');
}

/**
 * Helper to prepend CDN or webhost to asset URLs.
 * @param {String} path Unique id of the footnote
 * @returns {String} Absolute asset URL, prepended with CDN or webhost
 */
function assetUrl(path) {
  // Expecting a string - return the unmodified param if it's not a string.
  if (typeof path !== 'string') {
    return path;
  }
  const assetExtensions = [
  // images
  '.jpg', '.jpeg', '.webp', '.png', '.gif', '.png', '.svg',
  // documents
  '.csv', '.doc', '.docx', '.pdf', '.ppt', '.pptx', '.xls', '.xlsx',
  // videos
  '.mp4', '.webm'];

  // Expecting the string to contain an allowed asset extension.
  // Return the unmodified param if it does not contain an extension.
  if (!assetExtensions.some(extension => path.includes(extension))) {
    return path;
  }

  // Expecting the string to NOT start with http (absolute reference to externally hosted image)
  // Return the unmodified param if it begins with 'http'
  const protocol = 'http';
  if (path.slice(0, 4) === protocol) {
    return path;
  }

  // Expecting the string to begin with a '/' for consistency
  if (path.slice(0, 1) !== '/') {
    path = `/${path}`; // eslint-disable-line no-param-reassign
  }
  let domain;

  // use the CDN as the domain if it is enabled
  if (spaParams.siteParams.cdn.enabled) {
    domain = spaParams.siteParams.cdn.host;
  } else if (spaParams.siteParams.domain.ssl) {
    // check if we have a secure host and prepend the proper protocol
    domain = `https://${spaParams.siteParams.domain.hostname}`;
  } else {
    domain = `http://${spaParams.siteParams.domain.hostname}`;
  }
  if (spaParams.siteParams.env === 'local') {
    domain = spaParams.siteParams.contentRoot;
  }

  // If domain ends in '/' remove this character as the relative path will contain a leading '/'
  if (domain.slice(-1) === '/') {
    domain = domain.substring(0, domain.length - 1);
  }
  let buildId;

  // Get the Sparta build ID and append as a query param to ensure cache freshness
  if (document.body.dataset.buildId) {
    buildId = parseInt(document.body.dataset.buildId, 0);
  } else {
    buildId = null;
  }
  const absolutePath = `${domain}${path}?${buildId}`;
  return absolutePath;
}

export { activePageScrolling, applyNow, assetUrl, barker, cardDetails, compareProduct, currentCampaign, currentOffer, currentOfferBasedOffQueryParams, fileName, getObjectValue, getProgramRulesLink, htmlEscaper, learnMore, learnMoreUrl, omitCampaign, omitOffers, paginate, premiumBenefitsContent, premiumBenefitsHead, premiumBenefitsIcon, premiumBenefitsIconSwap, rating, stripList, stripTag, termsAndConditions, termsAndConditionsSB, token, tokenPopulated, updateApplyNowUrl };
